const u = (id) => `https://images.unsplash.com/${id}?q=80&w=1600&auto=format&fit=crop`;

export const SITE_URL = "https://viaggiaingrande.it";

export const LINKS = {
  whatsapp:
    "https://wa.me/393341925003?text=" +
    encodeURIComponent(
      "Ciao Laure, ho visto il tuo sito e vorrei saperne di più sul business dei viaggi"
    ),
  travelAdvantage:
    "https://join.traveladvantage.com/ambassador/membership?website=laurehila",
  mwrLife: "https://mwrlife.online/presentazione-italiana/laurehila/",
  amazon: "https://amzn.eu/d/03Hf58U2",
};

export const SOCIALS = [
  {
    name: "Instagram",
    handle: "@viaggia_in_grande",
    url: "https://www.instagram.com/viaggia_in_grande",
    icon: "instagram",
  },
  {
    name: "Facebook",
    handle: "Laure Hila",
    url: "https://www.facebook.com/share/19dyqpfdXo/?mibextid=wwXIfr",
    icon: "facebook",
  },
  {
    name: "LinkedIn",
    handle: "Laure Hila",
    url: "https://www.linkedin.com/in/laure-hila-21478034a",
    icon: "linkedin",
  },
  {
    name: "TikTok",
    handle: "@laurehila",
    url: "https://www.tiktok.com/@laurehila?_r=1&_t=ZN-9AAn0fJPhRO",
    icon: "tiktok",
  },
];

export const IMAGES = {
  hero: {
    url: u("photo-1571003123894-1f0594d2b5d9"),
    alt: "Resort mediterraneo affacciato sul mare sotto un cielo azzurro",
  },
  laure: {
    url: "/images/laure-ritratto.jpg",
    alt: "Laure Hila, fondatrice di Viaggia in Grande, davanti al mare",
  },
  proCappotto: {
    url: "/images/pro-cappotto.jpg",
    alt: "Laure Hila in cappotto nero e dolcevita chiaro, ritratto professionale",
  },
  proPontile: {
    url: "/images/pro-pontile.jpg",
    alt: "Laure Hila cammina sul pontile di un lago, ritratto professionale",
  },
  proBianco: {
    url: "/images/pro-bianco.jpg",
    alt: "Laure Hila vestita di bianco appoggiata tra le colonne sul lago",
  },
  proLago: {
    url: "/images/pro-lago.jpg",
    alt: "Laure Hila in cappotto nero sulla passeggiata a lago con una bicicletta",
  },
  santorini: {
    url: "/images/santorini.jpg",
    alt: "Laure Hila a Santorini con vista sulla caldera",
  },
  atene: {
    url: "/images/atene.jpg",
    alt: "Laure Hila davanti al Partenone di Atene",
  },
  toulouse: {
    url: "/images/toulouse.jpg",
    alt: "Laure Hila con la maglietta MWR Life davanti alla basilica di Saint-Sernin a Toulouse",
  },
  valigia: {
    url: "https://images.unsplash.com/photo-1515622472995-1a06094d2224?q=85&w=1600&auto=format&fit=crop",
    alt: "Valigia in pelle vintage con macchina fotografica, il piacere di preparare un viaggio",
  },
  scutari: {
    url: "/images/scutari.jpg",
    alt: "Laure Hila al castello di Scutari con il cartello MWR Life Making Wishes Real, vista sulla valle",
  },
  kruja: {
    url: "/images/kruja.jpg",
    alt: "Laure Hila a Kruja, Albania, davanti al museo nazionale di Skanderbeg",
  },
  hipAwards: {
    url: "/images/hip-awards.jpg",
    alt: "Laure Hila ai New Business Models Awards durante l'Horeca Professional Expo Italia",
  },
  shala: {
    url: "/images/shala.jpg",
    alt: "Laure Hila sulle rive del fiume Shala tra le montagne albanesi",
  },
  durres: {
    url: "/images/durres.jpg",
    alt: "Laure Hila a un evento MWR Life a Durazzo, Albania",
  },
  levico: {
    url: "/images/levico.jpg",
    alt: "Laure Hila con la maglietta TravelAdvantage sul pontile del Lago di Levico",
  },
  mwrEvento: {
    url: "/images/mwr-evento.jpg",
    alt: "Un evento MWR Life in Albania: formazione e community in sala",
  },
  murales: {
    url: "/images/murales.jpg",
    alt: "Laure Hila cammina davanti a un murales colorato dedicato alle persone",
  },
  lagoTramonto: {
    url: "/images/lago-tramonto.jpg",
    alt: "Laure Hila tra gli alberi sul lago al tramonto",
  },
  mwrPalco: {
    url: "/images/mwr-palco.jpg",
    alt: "Speaker sul palco davanti alla community durante un evento MWR Life (foto ufficiale MWR Life)",
  },
  mwrConvention: {
    url: "/images/mwr-convention.jpg",
    alt: "Formazione dal vivo a una convention MWR Life (foto ufficiale MWR Life)",
  },
  mwrCommunity: {
    url: "/images/mwr-community.jpg",
    alt: "La community MWR Life festeggia sul palco a fine evento (foto ufficiale MWR Life)",
  },
  dubai: {
    url: u("photo-1607414851776-f2fcc379fb48"),
    alt: "Skyline di Dubai con il Burj Khalifa al tramonto",
  },
  creta: {
    url: u("photo-1623784596164-084d8e403901"),
    alt: "Spiaggia di Balos a Creta con acqua turchese",
  },
  tenerife: {
    url: u("photo-1562059390-1a921dc4aa5c"),
    alt: "Costa rocciosa di Tenerife con l'oceano",
  },
  libroMood: {
    url: u("photo-1628024420612-4640108b4902"),
    alt: "Natura e acqua calma, l'atmosfera del libro Io e il mio 18",
  },
};

export const BOOK_COVER = {
  url: "https://m.media-amazon.com/images/I/61h6WwdDUML.jpg",
  alt: "Copertina del libro Io e il mio 18 — La storia di mia figlia Antonella di Laure Hila",
};

export const DESTINATIONS = [
  { name: "Santorini", country: "Grecia", image: IMAGES.santorini },
  { name: "Dubai", country: "Emirati Arabi Uniti", image: IMAGES.dubai },
  { name: "Creta", country: "Grecia", image: IMAGES.creta },
  { name: "Tenerife", country: "Spagna", image: IMAGES.tenerife },
  { name: "Atene", country: "Grecia", image: IMAGES.atene, pos: "center 55%" },
];

export const GALLERY_ITEMS = [
  { category: "Viaggi", image: IMAGES.santorini, label: "Santorini", pos: "center 55%" },
  { category: "Viaggi", image: IMAGES.atene, label: "Atene", pos: "center 78%" },
  { category: "Viaggi", image: IMAGES.proLago, label: "Passeggiata al lago", pos: "center 40%" },
  { category: "Viaggi", image: IMAGES.dubai, label: "Dubai" },
  { category: "Viaggi", image: IMAGES.creta, label: "Creta" },
  { category: "Viaggi", image: IMAGES.tenerife, label: "Tenerife" },
  { category: "Eventi", image: IMAGES.mwrEvento, label: "Evento MWR Life" },
  { category: "Eventi", image: IMAGES.mwrConvention, label: "Convention MWR Life" },
  { category: "Eventi", image: IMAGES.toulouse, label: "MWR Life — Toulouse", pos: "center 45%" },
  { category: "Eventi", image: IMAGES.mwrPalco, label: "Dal vivo, sul palco" },
  { category: "Eventi", image: IMAGES.mwrCommunity, label: "La community in festa" },
  { category: "Il mio percorso", image: IMAGES.proPontile, label: "Verso nuovi orizzonti", pos: "center 35%" },
  { category: "Il mio percorso", image: IMAGES.proCappotto, label: "Il nuovo capitolo", pos: "center 25%" },
  { category: "Il mio percorso", image: IMAGES.lagoTramonto, label: "Equilibrio", pos: "center 35%" },
  { category: "Persone", image: IMAGES.laure, label: "Laure", pos: "center 55%" },
  { category: "Persone", image: IMAGES.murales, label: "Tra le persone", pos: "center 75%" },
];

export const GALLERY_CATEGORIES = [
  "Tutte",
  "Viaggi",
  "Eventi",
  "Il mio percorso",
  "Persone",
];

export const NAV_ITEMS = [
  { label: "Home", path: "/" },
  { label: "Chi sono", path: "/la-mia-storia" },
  { label: "Viaggi", path: "/viaggi" },
  { label: "TravelAdvantage", path: "/travel-advantage" },
  { label: "Business", path: "/un-nuovo-modo-di-lavorare" },
  { label: "Skål Albania", path: "/skal-albania" },
  { label: "Il mio libro", path: "/libro" },
  { label: "Gallery", path: "/gallery" },
  { label: "Blog", path: "/blog" },
  { label: "Contatti", path: "/contatti" },
];

export const PERSON_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "Person",
  name: "Laure Hila",
  alternateName: "Viaggia in Grande",
  description:
    "Dopo 25 anni da dipendente ho scelto di rimettermi in gioco, imparare cose nuove e costruire un percorso più vicino alla vita che desidero.",
  address: {
    "@type": "PostalAddress",
    addressLocality: "Provincia di Bergamo",
    addressCountry: "IT",
  },
  sameAs: [
    "https://www.instagram.com/viaggia_in_grande",
    "https://www.facebook.com/share/19dyqpfdXo/?mibextid=wwXIfr",
    "https://www.linkedin.com/in/laure-hila-21478034a",
    "https://www.tiktok.com/@laurehila?_r=1&_t=ZN-9AAn0fJPhRO",
    "https://amzn.eu/d/03Hf58U2",
  ],
};
